import qs from 'qs';
import {http} from './index';
import { SecondClassSubjectApiTypes } from '@types';
const host = '/teaching-workbench';
/**获取项目科目列表 */
export const getPSSettingListTask = () => http.get(`${host}/answer/project`);
export const getPSSetting = (projectId:number) => http.get(`${host}/answer/project/${projectId}/subject`);
export const setPSSetting = (projectId:number,params:any) => http.post(`${host}/answer/project/${projectId}/subject/set`,params);///answer/project/{projectId}/subject/set


/**特殊计时规则 */
//规则弹窗的列表
export const getRuleListTask = (projectId:number) => http.get(`${host}/answer/project/${projectId}/outTime`);///answer/project/{projectId}/subject/set
//保存或更新特殊计时列表
export const saveRuleListTask = (projectId:number,params:any) => http.post(`${host}/answer/project/${projectId}/outTime/list`,params);

/**按产品线配置（特殊） */
export const getProductListTask = (params:any) => http.get(`${host}/answer/project/product`,params);

export const saveOrAddTask = (id:any,params:any) => http.post(`${host}/answer/project/${id}/product`,params);

export const getProjectsTask = () => http.get('/olaf/dictionary?typeId=1602');

//产品类型（all）
export const productTypeAllTask = () => http.get('/olaf/dictionary?typeId=10032');//1602 查询所有项目
//产品类型 (from project)
export const productTypeFromProjectTask = (projectId:any) => http.get(`/olaf/dictionary/parent-type-info?typeId=10032&parentId=${projectId}`);

//问题的一生
export const getQuestionLifeTask = (askId: number) => http.get(`/teaching-workbench/qa/ask/trajectory/${askId}`);

// 根据项目ID获取科目
export const getSubjectList = (projectId:number) => http.get(`${host}/answer/project/${projectId}/subject`);

// 根据项目ID与科目ID 获取二级科目
export const getSetSecondClassList = (params: SecondClassSubjectApiTypes) => http.get(`${host}/answer/project/two/subject?${qs.stringify(params)}`);
// 驳回功能设置列表
export const getSubjectReject = (params:any) => http.post(`${host}/reject-setting/${params.projectId}/list`,params);
// 驳回功能设置列表
export const getSubjectEdit = (params:any) => http.post(`${host}/reject-setting/edit`,params);
